import clsx from "clsx";
import mtg from "assets/shows/dixon4.jpg";

export default function Main() {
  return (
    <div className={parentContainer}>
      <div className="h-screen w-full">
        <img src={mtg} className={img} alt={altText} />
      </div>
      <div className={caption}>
        {/* Mind The Gap XXIII, Giving While Needing, 2022, Photo by Lynn Lane */}
        {/* Houston Botanic Garden, 2024, Photo by Hilary Schuhmacher */}
        WHITEWAVE SoloDuo Festival, 2025, Photo by Hisae Aihara
      </div>
    </div>
  );
}

const altText =
  "violet sitting on a bench with two bags to the left of them and a camera to their right ";
const parentContainer = clsx(
  "lg:h-screen flex flex-col justify-center md:mt-auto relative"
);
const img = clsx(
  "mb-[2px] self-center object-cover object-center h-full w-full"
);
const caption = clsx(
  " text-right absolute bottom-0 w-full right-0 px-2 text-xs text-white/20"
);
